import Vue from "vue";
import gameStateKeys from "@/assets/gameStateKeys";
import store from "store";

const currentVersionNumber = 1;

const state = Vue.observable({
  username: "",
  mute: false,
  stateKey: "day1",
  jobAccepted: false,
  versionNumber: currentVersionNumber,
});

loadFromStorage();

new Vue().$watch(
  () => state,
  state => {
    store.set("GameState", state);
  },
  { deep: true, immediate: true }
);

function loadFromStorage() {
  const gs = store.get("GameState");

  if (gs) {
    // load if current version
    if (gs.versionNumber === currentVersionNumber) {
      const gsKeys = Object.keys(gs);

      gsKeys.forEach(key => {
        state[key] = gs[key];
      });
    }
  }
}

export function incrementState() {
  const indexOfCurrentKey = gameStateKeys.indexOf(state.stateKey);
  if (indexOfCurrentKey + 1 < gameStateKeys.length)
    state.stateKey = gameStateKeys[indexOfCurrentKey + 1];
}

export function resetState() {
  store.remove("GameState");
}

export default state;
